export var LS_CONTINUED_KEY = 'connect-version-continued';
export var LS_CONNECT_APP_ID = 'connect-app-id';
export var LS_LOG_KEY = 'aspera-log-level';
export var LS_CONNECT_DETECTED = 'aspera-last-detected';
